<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-card title="Restoran Notları">
        <template v-if="dataList.length > 0">
          <b-list-group>
            <b-list-group-item
              v-for="item in dataList"
              :key="item.id"
            >
              <div class="font-weight-bold text-primary">
                {{ item.username }}
              </div>
              <div>{{ item.notes }}</div>
              <div class="text-muted font-small-2">
                {{ moment(item.created).format('llll') }} tarihinde oluşturuldu.
              </div>
            </b-list-group-item>
          </b-list-group>
        </template>
        <template v-else>
          <b-alert
            variant="info"
            show
          >
            <div class="alert-body text-center">
              Henüz not eklenmemiş.
            </div>
          </b-alert>
        </template>
        <hr>
        <address-text />
      </b-card>
      <b-button
        variant="primary"
        :disabled="dataItem.submitStatus"
        @click="submitForm"
      >
        Kaydet
      </b-button>
    </validation-observer>
  </div>
</template>
<script>
import {
  BCard, BButton, BListGroup, BListGroupItem, BAlert,
} from 'bootstrap-vue'
import AddressText from '@/views/Feedbacks/Elements/NotesText.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BButton,
    BListGroup,
    BListGroupItem,
    BAlert,
    AddressText,
    ValidationObserver,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['feedbackNotes/dataList']
    },
    dataItem() {
      return this.$store.getters['feedbackNotes/dataItem']
    },
    saveData() {
      return this.$store.getters['feedbackNotes/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$store.dispatch('feedbackNotes/getDataList', this.$route.params.id)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    localize('tr')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.dataItem.submitStatus = true
          this.dataItem.id_feedbacks = this.$route.params.id
          this.$store.dispatch('feedbackNotes/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
      return true
    },
  },
}
</script>
